import { AssetImage } from "./AssetImage";

// Full-screen splash on the delivered art (1264x848). The ring and "% loaded" sit where the art leaves room for them.
export const SplashScreen = ({ pct }) => {
  const r = 46;
  const c = 2 * Math.PI * r;
  return (
    <div data-testid="splash-screen" className="fixed inset-0 bg-black flex items-center justify-center overflow-hidden">
      <AssetImage id="bg_splash" className="absolute inset-0 w-full h-full object-cover opacity-60" style={{ filter: "blur(28px) saturate(0.8)", transform: "scale(1.1)" }} aria-hidden />
      <div className="relative" style={{ width: "min(100vw, calc(100vh * 1264 / 848))", aspectRatio: "1264 / 848" }}>
        <AssetImage id="bg_splash" className="absolute inset-0 w-full h-full" />
        <svg viewBox="0 0 100 100" className="absolute" style={{ left: "50%", top: "86.7%", width: "10.2%", transform: "translate(-50%, -50%)" }}>
          <circle cx="50" cy="50" r={r} fill="none" stroke="rgba(0,0,0,0.9)" strokeWidth="7" />
          <circle cx="50" cy="50" r={r} fill="none" stroke="#e6b94c" strokeWidth="4.5" strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={c * (1 - pct / 100)} transform="rotate(-90 50 50)" style={{ transition: "stroke-dashoffset 300ms ease" }} />
          <text x="50" y="56" textAnchor="middle" fill="#e6b94c" fontSize="22" fontFamily="JetBrains Mono, monospace" data-testid="splash-pct">{pct}</text>
        </svg>
        <div className="absolute bg-black text-center text-slate-300" style={{ left: "50%", top: "95.5%", width: "16%", height: "4%", transform: "translate(-50%, -50%)", fontSize: "min(1.6vh, 1.1vw)", lineHeight: "2.2" }} data-testid="splash-label">
          {pct}% loaded
        </div>
      </div>
    </div>
  );
};
